const DEFAULT_OPEN_HOUR = 8
const DEFAULT_OPEN_MINUTE = 30
const DEFAULT_CLOSE_HOUR = 17
const DEFAULT_CLOSE_MINUTE = 0

export function isBranchOpen(_branchName: string, date: Date): boolean {
  const nowMinutes = date.getHours() * 60 + date.getMinutes()
  const openMinutes = DEFAULT_OPEN_HOUR * 60 + DEFAULT_OPEN_MINUTE
  const closeMinutes = DEFAULT_CLOSE_HOUR * 60 + DEFAULT_CLOSE_MINUTE

  return nowMinutes >= openMinutes && nowMinutes < closeMinutes
}

export function getBranchDisplayHours(_branchName: string, _isSaturday: boolean): string {
  return "02:30 - 11:00"
}

export function getBranchClosingDisplay(_branchName: string): string {
  return "11:00"
}

export function hasExtendedSlotHours(_branchName: string): boolean {
  return false
}
